<template>
  <v-container
    fluid
    fill-height
    class="d-block"
  >
    <v-container
      class="pt-0"
    >
      <v-row>
        <v-col
          :cols="$store.state.mobile ? 12 : 8"
          :offset="$store.state.mobile ? 0 : 2"
        >
          <v-row>
            <v-col
              cols="12"
            >
              <v-row>
                <v-col
                  cols="auto"
                  class="py-0"
                >
                  <router-link to="/">
                    <v-img
                      :src="this.$store.state.webConfig.logo"
                      :width="$store.state.mobile ? 100 : 177"
                      :height="$store.state.mobile ? 36 : 64"
                    />
                  </router-link>
                </v-col>
              </v-row>
            </v-col>
            <v-divider />
          </v-row>
          <v-form
            ref="formMember"
            v-model="validMember"
          >
            <v-row>
              <v-col
                :cols="$store.state.mobile ? 12 : 6"
              >
                <div
                  style="font-size:40px"
                  class="font-medium  font-weight-bold"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    عضو
                  </template>
                  <template v-else>
                    Member
                  </template>
                </div>
                <div
                  class="text-h5 font-medium"
                  :class="$store.state.mobile ? 'mb-8' : 'mb-12'"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    الوصول إلى حسابك وسجل الطلبات كعضو.
                  </template>
                  <template v-else>
                    Access your account & orders history as member.
                  </template>
                </div>
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  type="email"
                  :label="$store.getters.languageGetter === '1' ? 'البريد الإلكتروني' : 'Email'"
                  outlined
                  :dense="!$store.state.mobile"
                  required
                />
                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  type="password"
                  :label="$store.getters.languageGetter === '1' ? 'كلمة المرور' : 'Password'"
                  outlined
                  :dense="!$store.state.mobile"
                  required
                />
                <div class="d-flex align-center">
                  <v-checkbox
                    v-model="saveToLocal"
                    hide-details
                    :label="$store.getters.languageGetter === '1' ? 'تذكرالحساب' : 'Remember me'"
                    class="mt-0 pt-0"
                  />
                  <v-spacer />
                  <div>
                    <template v-if="$store.getters.languageGetter === '1'">
                      السرهل نسيت كلمة
                    </template>
                    <template v-else>
                      Forget password
                    </template>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          color="#555"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span><template v-if="$store.getters.languageGetter === '1'">
                              الرجاء التواصل
                            </template>
                        <template v-else>
                          Please contact
                        </template>{{ $store.state.webConfig.mobile ? $store.state.webConfig.mobile : $store.getters.languageGetter === '1' ? 'نحن' : 'us' }}</span>
                    </v-tooltip>
                  </div>
                </div>
                <div
                  class=" align-center mt-6"
                  :class="$store.state.mobile ? '' : 'd-flex'"
                >
                  <v-btn
                    :block="$store.state.mobile"
                    :loading="submitting"
                    color="#333"
                    depressed
                    dark
                    :large="!$store.state.mobile"
                    :x-large="$store.state.mobile"
                    class="px-12 text-h5"
                    :class="$store.state.mobile ? 'mb-2' : ''"
                    @click="logInMember"
                  >
                    <div class="px-6">
                      <template v-if="$store.getters.languageGetter === '1'">
                        تسجيل دخول
                      </template>
                      <template v-else>
                        Sign In
                      </template>
                    </div>
                  </v-btn>
                  <v-spacer />
                  <div
                    class="text-h5"
                    :class="$store.state.mobile ? 'text-center' : ''"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      عميل جديد ؟
                    </template>
                    <template v-else>
                      New customer ?
                    </template> <router-link
                      to="/register"
                      class="text-decoration-underline font-medium"
                    >
                      <template v-if="$store.getters.languageGetter === '1'">
                        أبدأ هنا.
                      </template>
                      <template v-else>
                        Start here.
                      </template>
                    </router-link>
                  </div>
                </div>
              </v-col>
              <v-spacer />
              <v-col :cols="$store.state.mobile ? 12 : 3">
                <v-card
                  outlined
                  to="/"
                  class="mb-4"
                  style="background-color:transparent"
                >
                  <div
                    class="pa-4"
                    :class="$store.state.mobile ? 'text-center' : ''"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      العودة إلى الصفحة الرئيسية
                    </template>
                    <template v-else>
                      Return to the home page
                    </template>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'LogIn',
  data() {
    return {
      validMember: true,
      validGuest: true,
      submitting: false,
      email: '',
      emailRules: [(v) => !!v || 'Please enter your email', (v) => /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(v)
          || 'This is not a correct email address'],
      password: '',
      passwordRules: [(v) => !!v || 'Please enter your password', (v) => v.length >= 6 || 'Password should be more than 6 characters'],
      saveToLocal: false,
      tab: 0,
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
    ...mapActions([
      'logInAsync',
    ]),
    logInMember() {
      if (this.$refs.formMember.validate()) {
        this.submitting = true;
        this.logInAsync({ account: this.email, password: this.$store.$md5(this.password), save: this.saveToLocal }).then(() => {
          this.$router.replace('/');
        }).finally(() => {
          this.submitting = false;
        });
      }
    },
    logInGuest() {
      if (this.$refs.formGuest.validate()) {
        this.submitting = true;
        this.logInAsync({ account: this.email, password: this.$store.$md5(this.password), save: this.saveToLocal }).then(() => {
          this.$router.replace('/');
        }).finally(() => {
          this.submitting = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
